<template>
  <v-app>
    <!--v-app-bar app color="primary">
      <v-row align="center" no-gutters justify="center">
        <v-col align="center">
          <v-toolbar-title class="text-center">CHESPIK Digital Profile</v-toolbar-title>

       
        </v-col>
      </v-row>
    </v-app-bar-->

    <v-card width="500" height="auto" class="mx-auto mt-5" color="blue">
      <template v-if="$store.state.build_dealer_config === 'Chespik'">
        <v-img height="400" src="img/avatars/Digitalvc.jpeg">
          <v-row align="end" class="fill-height">
            <v-col align-self="end" class="px-16" cols="16">
              <v-avatar class="profile" color="grey" size="200">
                <v-img :src="dafaultUrl" height="200px"></v-img>
              </v-avatar>
            </v-col>
          </v-row>
        </v-img>
      </template>
      <template v-else>
        <v-img height="400" src="img/avatars/GlobalMediaHubli_Digitalvc.jpg">
          <v-row align="center" class="fill-height">
            <!--v-col align-self="end" class="px-16" cols="16"-->
            <v-col align="center">
              <v-avatar
                class="profile"
                color="rgb(0, 255, 255)"
                border-color="black"
                size="200"
              >
                <v-img :src="dafaultUrl" height="200"></v-img>
              </v-avatar>
            </v-col>
          </v-row>
        </v-img>
      </template>
    </v-card>
    <v-card
      width="500"
      height="auto"
      outlined
      shaped
      elevation="24"
      class="mx-auto"
      color="light-blue"
    >
      <v-col class="py-2">
        <v-list-item dark>
          <v-list-item-content>
            <v-list-item-title class="title"
              >{{ $store.state.profiledata.firstname }}
              {{ $store.state.profiledata.lastname }}</v-list-item-title
            >
            <v-list-item-subtitle>{{
              $store.state.profiledata.designation
            }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{
              $store.state.profiledata.companyname
            }}</v-list-item-subtitle>
          </v-list-item-content>
          <template v-if="enableedit">
            <v-btn color="warning" @click="EditProfile" fab medium dark>
              <v-icon small dark>mdi-pencil-outline</v-icon>Edit
            </v-btn>
          </template>
        </v-list-item>
      </v-col>
    </v-card>
    <v-card width="500" elevation="24" class="mx-auto">
      <v-row justify="space-around">
        <div class="my-6">
          <v-btn color="warning" @click="openCall" fab medium dark>
            <v-badge
              color="white"
              content="Call Me"
              bottom
              offset-x="45"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-phone</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div class="my-6">
          <v-btn color="green" @click="openWhatsapp" fab medium dark>
            <v-badge
              color="white"
              content="Whatsapp"
              bottom
              offset-x="55"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-whatsapp</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <div class="my-6">
          <v-btn
            color="rgba(18, 136, 136, 1)"
            @click="openLinkedin"
            fab
            medium
            dark
          >
            <v-badge
              color="white"
              content="Linkedin"
              bottom
              offset-x="45"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-linkedin</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <div class="my-6">
          <v-btn color="pink darken-1" @click="openInstagram" fab medium dark>
            <v-badge
              color="white"
              content="Instagram"
              bottom
              offset-x="55"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-instagram</v-icon>
            </v-badge>
          </v-btn>
        </div>
      </v-row>
      <v-row justify="space-around">
        <div class="my-6">
          <v-btn color="info" @click="openFacebook" fab medium dark>
            <v-badge
              color="white"
              content="Facebook"
              bottom
              offset-x="50"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-facebook</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div class="my-6">
          <v-btn color="info" @click="openTwitter" fab medium dark>
            <v-badge
              color="white"
              content="Twitter"
              bottom
              offset-x="45"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-twitter</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div class="my-6">
          <v-btn color="info" @click="openSkype" fab medium dark>
            <v-badge
              color="white"
              content="Skype"
              bottom
              offset-x="40"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-skype</v-icon>
            </v-badge>
          </v-btn>
        </div>
        <div class="my-6">
          <v-btn color="red" @click.native="sendEmail" fab medium dark>
            <v-badge
              color="white"
              content="E-mail"
              bottom
              offset-x="40"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-gmail </v-icon>
            </v-badge>
          </v-btn>
        </div>
      </v-row>
    </v-card>
    <v-card
      width="500"
      height="auto"
      outlined
      shaped
      elevation="24"
      class="mx-auto"
      color="cyan accent-3"
    >
      <v-col class="py-0">
        <v-list-item color="black" dark>
          <v-list-item-content>
            <v-list-item-title class="title">Company</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-card>

    <v-card width="500" class="mx-auto">
      <v-row justify="space-around">
        <v-dialog v-model="dialog" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="info" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Company"
                  bottom
                  offset-x="50"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-office-building</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Company Info</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.companyinfo }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="my-6">
          <v-btn color="info" @click="openWebSite" fab medium dark>
            <v-badge
              color="white"
              content="Website"
              bottom
              offset-x="45"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-web</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <v-dialog v-model="dialog3" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="red" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Accounts"
                  bottom
                  offset-x="50"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-currency-inr</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Account Details</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.paymentdetails }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog3 = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="my-6">
          <v-btn
            color="rgba(18, 136, 136, 1)"
            @click="openLocation"
            fab
            medium
            dark
          >
            <v-badge
              color="white"
              content="Location"
              bottom
              offset-x="50"
              offset-y="-20"
              x-large
            >
              <v-icon large dark>mdi-map-marker</v-icon>
            </v-badge>
          </v-btn>
        </div>
      </v-row>
    </v-card>

    <v-card
      width="500"
      height="auto"
      shaped
      elevation="24"
      class="mx-auto"
      color="cyan accent-3"
    >
      <v-col class="py-0 px-3">
        <v-list-item color="rgba(0, 0, 0, .4)" dark>
          <v-list-item-content>
            <v-list-item-title class="title">Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-card>
    <v-card width="500" class="mx-auto">
      <v-row justify="space-around">
        <v-dialog v-model="dialog4" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="info" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Profile"
                  bottom
                  offset-x="40"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-file-account</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Profile</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.profileinfo }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog4 = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog5" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="warning" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Milestones"
                  bottom
                  offset-x="55"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-star-circle</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Milestones</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.milestones }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog5 = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog6" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="success" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Awards"
                  bottom
                  offset-x="43"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-trophy</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Awards</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.awards }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog6 = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog7" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <div class="my-6">
              <v-btn color="red" v-on="on" fab medium dark>
                <v-badge
                  color="white"
                  content="Testimony"
                  bottom
                  offset-x="55"
                  offset-y="-20"
                  x-large
                >
                  <v-icon large dark>mdi-thumb-up</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title class="headline">Testimony</v-card-title>
            <v-card-text>
              {{ $store.state.profiledata.testimony }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog7 = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card>
    <v-footer dark padless color="primary lighten-1">
      <v-card tile class="primary lighten-1 white--text" width="100%">
        <v-row align="center" no-gutters justify="center">
          <v-col align="center">
            <v-card-text class="black--text pt-0">
              <span class="mr-1">Powered by</span>
              <template v-if="$store.state.build_dealer_config === 'Chespik'">
                <a href="http://www.fleetop.net" target="_blank">
                  <strong class="white--text pt-0">FleeTOP Technologies</strong>
                </a>
              </template>
              <template v-else>
                <a href="http://www.globalmediahubli.com" target="_blank">
                  <strong class="white--text pt-0">Global Media Hubli</strong>
                </a>
              </template>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
import firebase from "firebase";

export default {
  name: "profile",

  data() {
    return {
      dialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      hover: true,
      enableedit: false,
      dafaultUrl: "img/avatars/Digitalvc.jpeg"
    };
  },
  created() {
    var userurl = this.$route.path;
    var url = userurl.split("/Profile/");
    var db = firebase.database();
    var ref = db
      .ref("profiles")
      .orderByChild("profileurl")
      .equalTo(url[1]);
    ref.once("value", snapshot => {
      if (snapshot.exists()) {
        var name = snapshot.val();
        let key = Object.keys(name);
        key = key[0];
        name = Object.values(name);

        let expiry = name[0].expirydate;
        let expirydate = new Date(expiry);
        let currentdate = new Date();
        if (expirydate < currentdate) {
          if (this.$store.state.build_dealer_config === "Chespik") {
            alert(
              "Your Profile Subscription license is expired. Please reach out FleeTOP Technologies to renew it, Thank You"
            );
          }
          if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
            alert(
              "Your Profile Subscription license is expired. Please reach out Global Media Hubli to renew it, Thank You"
            );
          }

          this.$router.replace({ name: "Home" });
        }
        // do something if A is later than B

        this.$store.state.profiledata = name[0];
        this.$store.state.profiledata.key = key;
        this.dafaultUrl = this.$store.state.profiledata.imageurl;
        if (this.$store.state.user.loggedIn === true) this.enableedit = true;
        else this.enableedit = false;
      } else {
        if (this.$store.state.build_dealer_config === "Chespik") {
          alert(
            "Invalid URL..Please reach out  FleeTOP Tecnologies for more information"
          );
        }
        if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
          alert(
            "Invalid URL..Please reach out  Global Media Hubli for more information"
          );
        }

        this.$router.replace({ name: "Home" });
      }
    });
  },

  methods: {
    sendEmail() {
      window.location.assign("mailto:" + this.$store.state.profiledata.email);
    },
    openWhatsapp() {
      if (this.$store.state.build_dealer_config === "Chespik") {
        window.open(
          "https://api.whatsapp.com/send?phone=91" +
            this.$store.state.profiledata.whatsappnumber +
            "&text=Greetings!!,%20Got%20your%20reference%20from%20CHESPIK%20Profile%20Card.%20Want%20to%20know%20more%20about%20your%20products%20and%20services"
        );
      }
      if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
        window.open(
          "https://api.whatsapp.com/send?phone=91" +
            this.$store.state.profiledata.whatsappnumber +
            "&text=Greetings!!,%20Got%20your%20reference%20from%20Global%20Media%20Hubli%20Profile%20Card.%20Want%20to%20know%20more%20about%20your%20products%20and%20services"
        );
      }
    },
    openCall() {
      if (this.$store.state.profiledata.phonenumber.length > 10) {
        var tel = this.$store.state.profiledata.phonenumber.length - 10;
        var telinput = this.$store.state.profiledata.phonenumber.slice(tel);
        window.open("tel:" + "+91" + telinput);
      } else {
        window.open("tel:" + "+91" + this.$store.state.profiledata.phonenumber);
      }
    },
    openLocation() {
      if (this.$store.state.profiledata.locationlink !== " ") {
        var url = this.$store.state.profiledata.locationlink;
        var res = this.$store.state.profiledata.locationlink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.locationlink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.locationlink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openWebSite() {
      if (this.$store.state.profiledata.companywebsite !== " ") {
        var url = this.$store.state.profiledata.companywebsite;
        var res = this.$store.state.profiledata.companywebsite.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.companywebsite.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.companywebsite.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openLinkedin() {
      if (this.$store.state.profiledata.linkedinlink !== " ") {
        var url = this.$store.state.profiledata.linkedinlink;
        var res = this.$store.state.profiledata.linkedinlink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.linkedinlink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.linkedinlink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openInstagram() {
      if (this.$store.state.profiledata.instagramlink !== " ") {
        var url = this.$store.state.profiledata.instagramlink;
        var res = this.$store.state.profiledata.instagramlink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.instagramlink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.instagramlink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openFacebook() {
      if (this.$store.state.profiledata.facebooklink !== " ") {
        var url = this.$store.state.profiledata.facebooklink;
        var res = this.$store.state.profiledata.facebooklink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.facebooklink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.facebooklink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openTwitter() {
      if (this.$store.state.profiledata.twitterlink !== " ") {
        var url = this.$store.state.profiledata.twitterlink;
        var res = this.$store.state.profiledata.twitterlink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.twitterlink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.twitterlink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    openSkype() {
      if (this.$store.state.profiledata.skypelink !== " ") {
        var url = this.$store.state.profiledata.skypelink;
        var res = this.$store.state.profiledata.skypelink.substr(0, 5);

        if (res === "https") {
          url = this.$store.state.profiledata.skypelink.split("https://");
          window.open("https://" + url[1]);
        } else if (res === "http:") {
          url = this.$store.state.profiledata.skypelink.split("http://");
          window.open("https://" + url[1]);
        } else {
          window.open("https://" + url);
        }
      }
    },
    EditProfile() {
      this.$router.replace({ name: "EditRegisterDetails" });
    }
  }
};
</script>
